<template>
  <div>
    <user-detail-title
        first-bread="售后服务"
        second-bread="售后服务查看"
        first-url="/user/service"
        title-name="售后服务查看"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="名称">
          <p>{{ LookData.name }}</p>
        </el-form-item>
        <el-form-item label="图片">
          <el-image :src="'https://'+LookData.photoUrl"></el-image>
        </el-form-item>
        <el-form-item label="图片地址">
          <p>https://{{ LookData.photoUrl }}</p>
        </el-form-item>
        <el-form-item label="文字描述">
          <p>{{ LookData.description }}</p>
        </el-form-item>
        <el-form-item label="创建时间">
          {{ LookData.createTime }}

        </el-form-item>
        <el-form-item label="更新时间">
          {{ LookData.updateTime }}

        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ServiceLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/after/getById/',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>